/**
 * Nexus AI cross-app login (?x=) — see CROSS_APP_LOGIN_URL.md
 */
export const NEXUSSA_AI_ORIGIN = 'https://nexussa-ai.web.app';

/** sessionStorage key for credentials saved at login (needed to build ?x=) */
export const SESSION_CREDENTIALS_KEY = 'nexussa_ai_cross_login';

/**
 * @param {string} email
 * @param {string} password
 * @param {string} [baseUrl]
 * @param {number} [ttlSec]
 * @returns {string}
 */
export function buildNexussaAiLoginUrl(
  email,
  password,
  baseUrl = NEXUSSA_AI_ORIGIN,
  ttlSec = 300
) {
  const now = Math.floor(Date.now() / 1000);
  const json = JSON.stringify({
    v: 3,
    email: String(email).trim().toLowerCase(),
    password: String(password),
    exp: now + ttlSec,
    iat: now,
  });
  const encoder = new TextEncoder();
  const buf = encoder.encode(json);
  const rev = new Uint8Array(buf.length);
  for (let i = 0; i < buf.length; i++) {
    rev[i] = buf[buf.length - 1 - i];
  }
  let binary = '';
  for (let i = 0; i < rev.length; i++) {
    binary += String.fromCharCode(rev[i]);
  }
  const x = btoa(binary)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
  const origin = baseUrl.replace(/\/$/, '');
  return `${origin}/?x=${encodeURIComponent(x)}`;
}
